import { authClient } from "@/shared/lib/axios";
import {
	type GetErrorLogsResponse,
	GetErrorLogsResponseSchema,
	type GetExecutionLogsResponse,
	GetExecutionLogsResponseSchema,
} from "./workflow-log.types";

const endpoint = (workflowId: string) => `/workflows/${workflowId}/logs`;

export const workflowLogApi = {
	getExecutionLogs: async (
		workflowId: string,
		limit?: number,
	): Promise<GetExecutionLogsResponse> => {
		const { data } = await authClient.get(`${endpoint(workflowId)}/execution`, {
			params: limit !== undefined ? { limit: String(limit) } : undefined,
		});
		return GetExecutionLogsResponseSchema.parse(data);
	},

	getErrorLogs: async (
		workflowId: string,
		limit?: number,
	): Promise<GetErrorLogsResponse> => {
		const { data } = await authClient.get(`${endpoint(workflowId)}/errors`, {
			params: limit !== undefined ? { limit: String(limit) } : undefined,
		});
		return GetErrorLogsResponseSchema.parse(data);
	},
};
